import { type ReactElement } from 'react';
import { NationalFlagIds, NationalFlagLabels } from '../../../config/types.ts';

type NationalityFlagProps = {
  countryCode: keyof typeof NationalFlagIds;
  pixels?: number;
  className?: string;
};

export const NationalityFlag = ({
  countryCode,
  pixels = 24,
  className,
}: NationalityFlagProps): ReactElement | null => {
  // eslint-disable-next-line no-prototype-builtins
  if (!NationalFlagIds.hasOwnProperty(countryCode)) {
    return null;
  }

  return (
    <svg
      role="presentation"
      width={pixels}
      height={pixels}
      {...(className ? { className } : {})}
      data-testid="nationality-flag">
      <use
        aria-label={NationalFlagLabels[countryCode]}
        xlinkHref={`/v3/national-flags.svg#${NationalFlagIds[countryCode]}`}
      />
    </svg>
  );
};
